<h2 class="nomargin">What is the name of the tax?</h2>

<p>This is the name that the guests will see during the booking flow.</p>

<mat-form-field class="fw" id="search-input">
  <input
    matInput
    data-intercom-target="direct-tax-name-input"
    type="text"
    placeholder="Tax name (e.g. VAT)"
    (keyup.enter)="progress()"
    [(ngModel)]="tax.name"
    autofocus />

  <button mat-button *ngIf="tax?.name" matSuffix mat-icon-button aria-label="Clear" (click)="tax.name = ''">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>

<div style="margin-top: 16px" fxLayout fxLayoutAlign="end center">
  <sbnb-button
    data-intercom-target="direct-tax-name-continue"
    label="Continue"
    [disabled]="!tax?.name"
    (clicked)="progress()"></sbnb-button>
</div>
